import React, { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { CommonDropdownData, getPaymentVerificationData } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import moment from "moment";
import notify from "../../Helpers/ToastNotification";
import { Collapse, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import InputForm from "../../Components/InputForm/InputForm";
import OverflowTip from "../../Components/OverflowToolTip/OverflowToolTip";
import { debounceSearchRender } from "mui-datatables";
import SelectForm from "../../Components/SelectForm/SelectForm";
import DateForm from "../../Components/DateForm/DateForm";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { DATE_DISPLAY_FORMAT } from "../../Helpers/Constants/Constants";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { StyledBadge } from "../RegistrationRequest/RegistrationRequest";

const PaymentVerification = () => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const navigate = useNavigate();
  const context = getContext();

  const [dashboardData, setDashboardData] = useState([]);
  const [tabAllCount, setTabAllCount] = useState(0);
  const [tabPendingCount, setTabPendingCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [dashboardFilterOn, setDashboardFilterOn] = useState<boolean>(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [typeofApplicant, setTypeofApplicant] = useState<any>(null);
  const [typeofApplicantOptions, setTypeofApplicantOptions] = useState<any>([]);
  const [unitCode, setUnitCode] = useState<any>(null);
  const [unitCodeOptions, setUnitCodeOptions] = useState<any>([]);
  const [reset, setReset] = useState(false);
  const [tabClickValue, setTabClickValue] = useState("All-Request-tab");
  const [tabClickAPIcall, setTabClickAPIcall] = useState({
    AllRequest: true,
    PendingRequest: false,
  });
  const [tabClickClass, setTabClickClass] = useState({
    AllRequest: "tab-pane fade  active show",
    PendingRequest: "tab-pane fade",
  });
  const [isAllRequestSelected, setIsAllRequestSelected] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      showLoader();
      await onLoadDashboardData();
      hideLoader();
    })();
  }, [start, sortColumn, sortDirection, searchText, reset]);

  const getUnitCodeDropDownDataApiCall = async () => {
    showLoader();

    let requestParams = {
      dropdownName: "unitcodedd",
    };
    const res = await APICall(CommonDropdownData, requestParams);

    if (res && res.Data.length > 0) {
      let options = await res.Data;

      await setUnitCodeOptions(options);

      hideLoader();
    } else {
      await setUnitCodeOptions([]);
      notify(1, res.Message);
      hideLoader();
    }
  };

  const getTypeofApplicantDropDownDataApiCall = async () => {
    showLoader();

    const TypeofApplicantDropDownData = [
      { value: 1, label: "Officers, M&M and Core Users (Mahindra)" },
      { value: 2, label: "Staff, Workmen and Other Companies (Other)" },
    ];
    setTypeofApplicantOptions(TypeofApplicantDropDownData);

    hideLoader();
  };

  useEffect(() => {
    getUnitCodeDropDownDataApiCall();
    getTypeofApplicantDropDownDataApiCall();
  }, []);

  const onClickOftab = (event: any) => {
    setTabClickValue(event.target.id);
    onTabClickAPIcall(event.target.id);

    if (event.target.id == "All-Request-tab") {
      setIsAllRequestSelected(true);
    } else {
      setIsAllRequestSelected(false);
    }
  };

  const onLoadDashboardData = async () => {
    showLoader();

    // let statusIds =
    //   context.loggedInAs?.value === RoleEnum.Admin
    //     ? ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam
    //     : ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee;
    let statusIdArr = [];
    if (context?.loggedInAs?.value === RoleEnum.Admin) {
      statusIdArr = [ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam];
    } else if (context?.loggedInAs?.value === RoleEnum.EnrollmentCommittee) {
      statusIdArr = [ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee];
    }

    if (isAllRequestSelected) {
      if (context?.loggedInAs?.value === RoleEnum.Admin) {
        statusIdArr = [
          ...statusIdArr,
          ApplicationStatus.MemberRegistrationModule_PendingWithHRHOD,
          ApplicationStatus.MemberRegistrationModule_RejectedHRHOD,
          ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails,
          ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
          ApplicationStatus.MemberRegistrationModule_MemberRequestApproved,
          ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted,
          ApplicationStatus.MemberRegistrationModule_MemberRequestRejected,
          ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
        ];
      } else {
        statusIdArr = [
          ...statusIdArr,
          ApplicationStatus.MemberRegistrationModule_MemberRequestApproved,
          ApplicationStatus.MemberRegistrationModule_MemberIDCreationCompleted,
          ApplicationStatus.MemberRegistrationModule_MemberRequestRejected,
          ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
        ];
      }
    }

    let statusIds = statusIdArr.join(",");

    let requestParams = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      TypeofApplicantId: typeofApplicant && typeofApplicant.length > 0 ? typeofApplicant.map(({ value }) => value).toString() : "",
      UnitCodeId: unitCode && unitCode.length > 0 ? unitCode.map(({ value }) => value).toString() : "",
      FromDate: fromDate === null || fromDate === "" ? null : moment(fromDate).format("YYYY-MM-DD"),
      ToDate: toDate === null || toDate === "" ? null : moment(toDate).format("YYYY-MM-DD"),
      StatusId: statusIds,
      UserId: 1,
      RoleId: 1,
    };

    const res = await APICall(getPaymentVerificationData, requestParams);

    if (res !== null && res.Data.length > 0) {
      setDashboardData(res.Data);
      setCount(res.Data[0].TotalCount);
    } else {
      setDashboardData([]);
      setCount(0);
    }
    if (isAllRequestSelected) {
      setTabAllCount(res?.Data?.[0]?.TotalCount || 0);
    } else {
      setTabPendingCount(res?.Data?.[0]?.TotalCount || 0);
    }

    hideLoader();
  };

  const onTabClickAPIcall = async (param: any) => {
    await resetFunction();
    setDashboardFilterOn(false);
    switch (param) {
      case "All-Request-tab":
        setTabClickAPIcall({
          AllRequest: true,
          PendingRequest: false,
        });
        setTabClickClass({
          AllRequest: "tab-pane fade  active show",
          PendingRequest: "tab-pane fade",
        });
        break;
      case "Pending-Request-tab":
        setTabClickAPIcall({
          AllRequest: false,
          PendingRequest: true,
        });
        setTabClickClass({
          AllRequest: "tab-pane fade",
          PendingRequest: "tab-pane fade  active show",
        });
        break;
      default:
        setTabClickAPIcall({
          AllRequest: true,
          PendingRequest: false,
        });
        setTabClickClass({
          AllRequest: "tab-pane fade  active show",
          PendingRequest: "tab-pane fade",
        });
        break;
    }
  };

  const onFilterButtonClick = async (event) => {
    await setDashboardFilterOn(!event);
  };

  const onClickFunction = async (event, action) => {
    if (action === "Apply") {
      let isEmptyReqObj = false;
      if (dashboardFilterOn === true) {
        let reqFilterObj = {
          eventApplicantId: typeofApplicant && typeofApplicant.length > 0 ? typeofApplicant.map(({ value }) => value).toString() : "",
          unitCodeId: unitCode && unitCode.length > 0 ? unitCode.map(({ value }) => value).toString() : "",
          fromDate: fromDate === null || fromDate === "" ? null : moment(fromDate).format("YYYY-MM-DD"),
          toDate: toDate === null || toDate === "" ? null : moment(toDate).format("YYYY-MM-DD"),
        };
        isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
          if (f === "" || f === null || f === undefined) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (isEmptyReqObj === true) {
        notify(1, "Select at least one filter.");
      } else if (moment(fromDate).isAfter(moment(toDate))) {
        notify(1, "From Date should be less than To Date");
      } else if (fromDate && !toDate) {
        notify(1, "Select To Date");
      } else if (toDate && !fromDate) {
        notify(1, "Select From Date");
      } else {
        await onLoadDashboardData();
      }
    } else if (action === "Reset") {
      await resetFunction();
    }
  };

  const dashboardOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    customSearchRender: debounceSearchRender(500),
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    textLabels: {
      body: {
        noMatch: "No data found",
      },
    },
  };

  const resetFunction = () => {
    // setFormErrors({});
    // formErrorObj = {};

    setTypeofApplicant(null);
    setUnitCode(null);
    setFromDate(null);
    setToDate(null);

    setReset(!reset);
  };

  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "typeofApplicant") {
      setTypeofApplicant(event);
    }

    if (apiFieldName === "unitCode") {
      setUnitCode(event);
    }
  };

  const dashboardGridColumns = [
    {
      name: "Id",
      label: "ID",
      options: {
        display: false,
      },
    },
    {
      name: "TokenNo",
      label: "Token Number",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },
    {
      name: "Name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },
    {
      name: "InternalTeamEvaluator",
      label: "Internal Team Evaluator",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },
    {
      name: "TransactionDate",
      label: "Transaction Date",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {moment(value).format(DATE_DISPLAY_FORMAT)}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },
    {
      name: "TransactionReferenceNo",
      label: "Transaction Reference No",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },
    {
      name: "StatusId",
      label: "StatusId",
      options: {
        filter: true,
        sort: true,
        sortDescFirst: true,
        display: false,
      },
    },
    {
      name: "StatusTitle",
      label: "Status",
      options: {
        filter: true,
        sort: false,
        sortDescFirst: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <>
              <OverflowTip>
                <Typography fontFamily={"Georama-Regular"} fontSize={"14px"} component={"span"} noWrap={true}>
                  {value}
                </Typography>
              </OverflowTip>
            </>
          );
        },
      },
    },
    {
      name: "Id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        display: true,
        setCellProps: () => ({
          style: { minWidth: "120px", maxWidth: "120px" },
        }),
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex][0];
          let statusId = tableMeta.tableData[tableMeta.rowIndex][6];
          if (statusId) {
            statusId = parseInt(statusId);
          }

          if (
            (context.loggedInAs?.value === RoleEnum.Admin && statusId === ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam) ||
            (context.loggedInAs?.value === RoleEnum.EnrollmentCommittee && statusId === ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee)
          ) {
            return (
              <>
                <Tooltip title="edit" className="ml-2">
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/PaymentVerificationView", {
                        state: { id: id, ShowHideButton: false },
                      });
                    }}
                  >
                    <i className="fas fa-edit"></i>
                    {/* <i className="fa fa-pencil"></i> */}
                  </a>
                </Tooltip>
              </>
            );
          } else {
            return (
              <Tooltip title="view">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/PaymentVerificationView", {
                      state: { id: id, ShowHideButton: true },
                    });
                  }}
                >
                  <i className="fas fa-eye"></i>
                </a>
              </Tooltip>
            );
          }
        },
      },
    },
  ];

  return (
    <>
      <div className="">
        <div className="">
          <div className="clearfix"></div>
          <div className="page-content row filter-row-container m-0">
            <div className="transformer-tabs col-lg-12 col-md-12">
              <div className="meeting-tabs tabs-main col-lg-12 pl-0">
                <nav className="tabs mr-sm-4 --jsfied">
                  <ul className="nav nav-pills  float-left -primary" id="pills-tab" role="tablist">
                    <StyledBadge badgeContent={tabAllCount} color="error" className="mr-3" max={99} invisible={true}>
                      <li className="nav-item" role="presentation">
                        <a
                          key="Dashboard"
                          className={tabClickValue === "All-Request-tab" ? "nav-link active" : "nav-link"}
                          id="All-Request-tab"
                          data-toggle="pill"
                          role="tab"
                          aria-controls="pills-MA"
                          aria-selected={tabClickValue === "All-Request-tab" ? "true" : "false"}
                          onClick={onClickOftab}
                        >
                          All Requests
                        </a>
                      </li>
                    </StyledBadge>
                    <StyledBadge badgeContent={tabPendingCount} color="error" className="mr-3" max={99} invisible={true}>
                      <li className="nav-item" role="presentation">
                        <a
                          key="Dashboard"
                          className={tabClickValue === "Pending-Request-tab" ? "nav-link active" : "nav-link"}
                          id="Pending-Request-tab"
                          data-toggle="pill"
                          role="tab"
                          aria-controls="pills-MA"
                          aria-selected={tabClickValue === "Pending-Request-tab" ? "true" : "false"}
                          onClick={onClickOftab}
                        >
                          Pending Requests
                        </a>
                      </li>
                    </StyledBadge>
                  </ul>
                </nav>

                <ul className="float-right filter-icon ml-2 mt-1">
                  <li onClick={() => onFilterButtonClick(dashboardFilterOn)} className="filter-btn">
                    <a className="filter-btn">
                      <i className="fa fa-filter"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="page-content row filter-row-container mb-0 ml-0 mr-0">
            <div className="col-lg-12 p-0">
              <div className="row">
                <div className="col-lg-4 col-md-4"></div>
                <div className="col-lg-4 col-md-2"></div>
                <div className="col-lg-4 col-md-6">
                  <div className="row d-flex justify-content-end mr-xl-2 mr-md-2">
                    <div className="col-lg-12 mt-1 p-0 searchInput">
                      <InputForm
                        value={searchText}
                        placeholder={"Search"}
                        isDisabled={false}
                        textArea={false}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                        }}
                      />
                      <i className="fa fa-search ml-2" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="clearfix"></div>
          <Collapse in={dashboardFilterOn}>
            <div className="filter-content pt-2">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">Type of Applicant</label>
                    <SelectForm
                      options={typeofApplicantOptions}
                      placeholder="Type of Applicant"
                      isDisabled={false}
                      value={typeofApplicant}
                      onChange={(event) => selectOnChange(event, "typeofApplicant")}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    {/* <p style={{ color: "red" }}>
                      {formErrors["typeofApplicant_isEmpty"]}
                    </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">Unit Code</label>
                    <SelectForm
                      options={unitCodeOptions}
                      placeholder="Unit Code"
                      isDisabled={false}
                      value={unitCode}
                      onChange={(event) => selectOnChange(event, "unitCode")}
                      isMulti={true}
                      noIndicator={false}
                      noSeparator={false}
                    />
                    {/* <p style={{ color: "red" }}>
                      {formErrors["unitCode_isEmpty"]}
                    </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-sm-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">From Date</label>
                    <br />
                    <div className="">
                      <div className="input-group date selectdate">
                        <DateForm isDisabled={false} value={fromDate} onChange={(e) => setFromDate(e)} placeholder="DD-MM-YYYY" />
                      </div>
                    </div>
                    {/* <p style={{ color: "red" }}>
                      {formErrors["fromDate_isEmpty"]}
                    </p> */}
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                  <div className="form-group">
                    <label className="col-form-label">To Date</label>
                    <br />
                    <div className="">
                      <div className="input-group date selectdate">
                        <DateForm isDisabled={false} value={toDate} onChange={(e) => setToDate(e)} placeholder="DD-MM-YYYY" />
                      </div>
                    </div>
                    {/* <p style={{ color: "red" }}>
                      {formErrors["toDate_isEmpty"]}
                    </p> */}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="float-right">
                    <button className="btn btn-cancel" style={{ marginLeft: 5 }} onClick={(e) => onClickFunction(e, "Reset")}>
                      Reset
                    </button>
                    <button className="btn btn-info" style={{ marginLeft: 5 }} onClick={(e) => onClickFunction(e, "Apply")}>
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
          <>
            <div
              style={{
                paddingTop: "10px",
                paddingBottom: "10px",
                marginLeft: "1px",
              }}
              className="col-lg-12 px-0 py-2"
            >
              <div className="tab-content">
                <div id="Request" role="tabpanel" aria-labelledby="Request-tab" key="Dashboard">
                  {dashboardData && dashboardData.length >= 0 && <DynamicGrid options={dashboardOptions} data={dashboardData} columns={dashboardGridColumns} />}
                </div>
              </div>
            </div>
          </>
        </div>
      </div>
    </>
  );
};

export default PaymentVerification;
